import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import { Button, message, Typography } from 'antd';
import ProCard from '@ant-design/pro-card';
import { DeleteOutlined } from '@ant-design/icons';
import {
  ProFormSelect,
  ProFormList,
  ProFormGroup,
  ProFormText,
  ProFormDependency,
} from '@ant-design/pro-form';
import { SelectDepartmentOnly } from 'components/input';
import './style.less';
import AddTeamMemberModal from './AddTeamMemberModal';

const getTeamMemberType = (index) => {
  if (index === 0) {
    return {
      PL: 'Project Leader',
      RCPL: 'RCPL',
    };
  }

  return {
    COPL: 'Co-PL',
    MEMBER: 'Team Member',
  };
};
const { Title } = Typography;

const TeamMemberList = ({ disabled }) => {
  const ref = useRef();

  return (
    <>
      <ProFormList
        actionRef={ref}
        className="team-member-list"
        label={<Title level={4}>Particulars of the applicants</Title>}
        name="team"
        creatorButtonProps={false}
        rules={[
          {
            required: true,
            message: 'please enter at least one member',
          },
        ]}
        itemRender={({ listDom }, { index }) => (
          <ProCard
            bordered
            style={{ marginBottom: 8 }}
            title={`Team member ${index + 1}`}
            extra={
              <Button
                danger
                type="primary"
                icon={<DeleteOutlined />}
                disabled={disabled}
                onClick={() => {
                  if (index > 0) {
                    ref.current?.remove(index);
                  } else {
                    message.error('You must be the project leader / RCPL');
                  }
                }}
              >
                Remove
              </Button>
            }
            bodyStyle={{ paddingBottom: 0 }}
          >
            {listDom}
          </ProCard>
        )}
      >
        {(_f, index) => {
          return (
            <>
              <ProFormText
                name="user"
                label="user"
                width="sm"
                fieldProps={{
                  readOnly: true,
                }}
                hidden={true}
              />
              <ProFormText
                name="userFromHroStaff"
                label="userFromHroStaff"
                width="sm"
                fieldProps={{
                  readOnly: true,
                }}
                hidden={true}
              />
              <ProFormGroup>
                <ProFormSelect
                  label="Team member type"
                  name="teamMemberType"
                  width="lg"
                  valueEnum={getTeamMemberType(index)}
                  disabled={disabled}
                  rules={[
                    {
                      required: true,
                    },
                    ({ getFieldValue }) => ({
                      validator(_, value) {
                        if (
                          value === 'COPL' &&
                          getFieldValue(['team', 0, 'teamMemberType']) === 'PL'
                        ) {
                          return Promise.reject(
                            new Error(
                              'PL & Co-PL cannot be selected at the same time'
                            )
                          );
                        }
                        return Promise.resolve();
                      },
                    }),
                  ]}
                />
                <ProFormDependency name={['user', 'userFromHroStaff']}>
                  {({ user, userFromHroStaff }) => (
                    <ProFormText
                      label="Name"
                      name="name"
                      width="lg"
                      rules={[{ required: true }]}
                      readonly={!!user || !!userFromHroStaff || disabled}
                      fieldProps={{
                        readOnly: !!user || !!userFromHroStaff || disabled,
                      }}
                    />
                  )}
                </ProFormDependency>
              </ProFormGroup>
              <ProFormGroup>
                <SelectDepartmentOnly
                  label="Department"
                  name="department"
                  width="lg"
                  disabled={disabled}
                  rules={[{ required: true }]}
                />
                <ProFormText
                  label="Position"
                  name="position"
                  width="lg"
                  disabled={disabled}
                  rules={[{ required: true }]}
                />
              </ProFormGroup>
              <ProFormGroup>
                <ProFormDependency name={['user', 'userFromHroStaff']}>
                  {({ user, userFromHroStaff }) => (
                    <ProFormText
                      label="Email"
                      name="email"
                      width="lg"
                      rules={[
                        {
                          type: 'email',
                          message: 'This is not valid email!',
                        },
                        {
                          required: true,
                        },
                      ]}
                      readonly={!!user || !!userFromHroStaff || disabled}
                      fieldProps={{
                        readOnly: !!user || !!userFromHroStaff || disabled,
                      }}
                    />
                  )}
                </ProFormDependency>
                <ProFormDependency name={['user', 'userFromHroStaff']}>
                  {({ user, userFromHroStaff }) => (
                    <ProFormText
                      label="Net ID"
                      name="netId"
                      width="lg"
                      rules={[{ required: true }]}
                      readonly={!!user || !!userFromHroStaff || disabled}
                      fieldProps={{
                        readOnly: !!user || !!userFromHroStaff || disabled,
                      }}
                    />
                  )}
                </ProFormDependency>
              </ProFormGroup>
            </>
          );
        }}
      </ProFormList>
      <AddTeamMemberModal actionRef={ref} disabled={disabled} />
    </>
  );
};

TeamMemberList.defaultProps = {
  disabled: false,
};

TeamMemberList.propTypes = {
  disabled: PropTypes.bool.isRequired,
};

export default TeamMemberList;
